@if (isLoading()) {
  <ngx-skeleton-loader
    class="custom-skeleton"
    [count]="1"
    animation="pulse"
    appearance="line"
    [theme]="{height: '40px', background: 'var(--skeleton-color)'}"
  />

  <div class="row mb-4">
    @for (_ of [].constructor(3); track $index) {
      <div class="col-md-4">
        <ngx-skeleton-loader
          class="custom-skeleton"
          [count]="1"
          animation="pulse"
          appearance="line"
          [theme]="{height: '222.56px', background: 'var(--skeleton-color)'}"
        />
      </div>
    }
  </div>


  <ul class="nav nav-tabs mb-1">
    <ngx-skeleton-loader
      class="custom-skeleton"
      [count]="1"
      animation="pulse"
      appearance="line"
      [theme]="{height: '40.51px', width:'290.64px', background: 'var(--skeleton-color)'}"
    />

  </ul>
  <div *ngIf="activeTab === 'services'">
    <div class="card">
      <ngx-skeleton-loader
        class="custom-skeleton"
        [count]="3"
        animation="pulse"
        appearance="line"
        [theme]="{height: '40.51px', width:'99.75px', background: 'var(--skeleton-color)'}"
      />
    </div>
  </div>
  <div class="d-flex flex-column gap-y-2">
    <ul class="nav nav-tabs m-1 p-0">
      <ngx-skeleton-loader
        class="custom-skeleton"
        [count]="1"
        animation="pulse"
        appearance="line"
        [theme]="{height: '40.51px', width:'1293.7px', background: 'var(--skeleton-color)'}"
      />
    </ul>
  </div>
  <div class="d-flex justify-content-between gap-2">
    <div class="card col-md-6">
      <ngx-skeleton-loader
        class="custom-skeleton"
        [count]="1"
        animation="pulse"
        appearance="line"
        [theme]="{height: '173.56px', width:'642.84px', background: 'var(--skeleton-color)'}"
      />
    </div>

    <div class="card col-md-3">
      <ngx-skeleton-loader
        class="custom-skeleton"
        [count]="1"
        animation="pulse"
        appearance="line"
        [theme]="{height: '173.56px', width:'321.42px', background: 'var(--skeleton-color)'}"
      />
    </div>
    <div class="card col-md-3">
      <ngx-skeleton-loader
        class="custom-skeleton"
        [count]="1"
        animation="pulse"
        appearance="line"
        [theme]="{height: '173.56px', width:'321.42px', background: 'var(--skeleton-color)'}"
      />
    </div>
  </div>


} @else {

  <div class="card mb-0">
    <div class="card-header py-1">
      <app-page-title [breadcrumbItems]="breadCrumbItems" [title]="data() | renterName">
        <button class="btn btn-primary me-2" (click)="onEdit()">
          <i class="bi bi-pencil-square"></i> {{ 'INVOICES.EDIT'| translate }}
        </button>
        <button class="btn btn-danger me-2" (click)="delete(data().id)">
          <i class="las la-trash-alt"></i> {{ 'DELETE'| translate }}
        </button>
      </app-page-title>
    </div>
  </div>
  <div class="py-4 resident-profile-wrapper">
    <div class="row align-items-stretch">
      <!-- Overview Card -->
      <div class="col-md-8 mt-3 mt-md-0 d-flex flex-column">
        <div class="card shadow-sm border-0 p-3 h-100">
          <div class="d-flex justify-content-between align-items-start">
            <div>
              <h5 class="fw-bold">{{ 'COMPANIES.OVERVIEW'|translate }}</h5>
              <p class="text-muted small">{{ 'COMPANIES.BASIC_INFO'| translate }}</p>
            </div>
            <span
              class="badge bg-success bg-opacity-10 text-success px-3 py-1 rounded-pill">{{ 'APARTMENT.ACTIVE'|translate }}</span>
          </div>

          <hr>

          <!-- User Info -->
          <div class="d-flex align-items-center gap-3">
            <div class="rounded-circle d-flex justify-content-center align-items-center bg-light"
                 style="width: 40px; height: 40px;">
              <i class="las la-user text-primary fs-4"></i>
            </div>
            <div>
              <h4 class="mb-0 fw-semibold">{{ data()| renterName }}</h4>
            </div>
          </div>

          <hr>

          <!-- Contact & Address -->
          <div class="row">
            <div class="col-md-6">
              <h4 class="fw-semibold">{{ 'RESIDENTS.CONTACTINFO'| translate }}</h4>
              <p class="mb-1"><i class="las la-envelope"></i> {{ 'APARTMENT.EMAIL' |translate }}: {{ data().email }}</p>
              <p class="mb-1"><i class="las la-phone"></i> {{ 'APARTMENT.TELEPHONE'|translate }}: {{ data().phoneNumber }}</p>
            </div>
            <div class="col-md-6">
              <h4 class="fw-semibold">{{ 'APARTMENT.ADDRESS'|translate }}</h4>
              <p class="mb-1"><i
                class="las la-map-marker"></i> {{ data().street }} {{ data().houseNumber }}, {{data().postalCode}} {{ data()?.city }}</p>
            </div>
          </div>

          <hr>

          <!-- Created & Updated -->
          <div class="row">
            <div class="col-md-6">
              <h4 class="fw-semibold">{{ 'READINGS.CREATEDDATE'|translate }}</h4>
              <p class="mb-0 text-secondary small">{{ data().createdAt|date }}</p>
            </div>
            <div class="col-md-6">
              <h4 class="fw-semibold">{{ 'RESIDENTS.UPDATE_DATE'|translate }}</h4>
              <p class="mb-0 text-secondary small">{{ data().updatedAt|date }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Bank Details Card -->
      <div class="col-md-4 mt-3 mt-md-0 d-flex flex-column">
        <div class="card shadow-sm border-0  p-3 h-100">
          <h5 class="fw-bold">{{ 'RESIDENTS.BANK_INFO'|translate }}</h5>
          <p class="text-muted small">{{ 'DASHBOARD.PAYMENTACTIVITY'|translate }}</p>

          <hr>

          <h6 class="text-muted small">{{ 'APARTMENT.ACCOUNT_HOLDER'|translate }}</h6>
          <p class="fw-semibold">{{ data().bankAccountHolder }}</p>

          <h6 class="text-muted text-uppercase small">{{ 'RESIDENTS.BANK_BIC'|translate }}</h6>
          <p class="fw-bold">{{ data().bankBic }}</p>

          <h6 class="text-muted text-uppercase small">{{ 'APARTMENT.IBAN'|translate }}</h6>
          <p class="fw-bold">{{ data().bankIban }}</p>

        </div>
      </div>
    </div>

    <!-- Tabs for different sections -->
    <ul class="nav custom-tabs cursor-pointer mb-1">
      @for (tab of tabs; track tab) {
        <li class="nav-item">
          <a
            class="nav-link"
            [ngClass]="{ 'active': activeTab === tab.key }"
            (click)="setActiveTab(tab.key)"
          >
            {{ tab.label | translate }}
          </a>
        </li>
      }
    </ul>
    @switch (activeTab) {
      @case ('renters-apartments') {
        <app-apartments [renterId]="id"></app-apartments>
      }
      @case ('services') {
        <app-contracts [renterId]="id"></app-contracts>
      }
      @case ('payments') {
        <app-balances [renter]="data()"></app-balances>
      }
      @case ('invoices') {
        <app-invoices-history [renterId]="id"></app-invoices-history>
      }
      @case ('documents') {
        <app-documents [renterId]="id" [hideActions]="true"></app-documents>
      }
    }
  </div>
}

